import * as THREE from 'three';

// What's in frame. Things out of the camera's view aren't drawn, animated or
// updated at all (the simulation runs on regardless: only what's drawn
// depends on where the camera looks). Our own ship is always drawn.

/** Extent of a ship and her rig in design metres: a sphere about this point takes in hull, spars and masts over the side. */
export const SHIP_BOUND_CENTRE = { x: 2, y: 18, z: 0 };
export const SHIP_BOUND_RADIUS = 44;

/**
 * Should a ship (bounding sphere `centre`, `radius`) be drawn? When any part
 * of her is in the camera's view; or, out of it, when she lies between the
 * light and our ship close enough to throw her shadow on our decks (the
 * key light's shadow map reaches `shadowHalf` either side of us and starts
 * `shadowReach` sunward of us).
 */
export function shipInFrame(
  frustum: THREE.Frustum, centre: THREE.Vector3, radius: number,
  us: THREE.Vector3, lightDir: THREE.Vector3 | null, shadowHalf: number, shadowReach = Infinity,
): boolean {
  if (frustum.intersectsSphere(tmpSphere.set(centre, radius))) return true;
  if (!lightDir) return false;
  const dx = centre.x - us.x, dy = centre.y - us.y, dz = centre.z - us.z;
  const along = dx * lightDir.x + dy * lightDir.y + dz * lightDir.z;
  const lateral = Math.sqrt(Math.max(0, dx * dx + dy * dy + dz * dz - along * along));
  return along > -radius && along < shadowReach + radius && lateral < shadowHalf + radius;
}

/** The camera's view volume this frame. */
export function cameraFrustum(camera: THREE.Camera, out: THREE.Frustum): THREE.Frustum {
  return out.setFromProjectionMatrix(tmpM.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse));
}

const tmpSphere = new THREE.Sphere();
const tmpM = new THREE.Matrix4();
